var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{attrs:{"to":"/new/server/"}},[_c('vs-button',{staticClass:"rounded-pill bg-h-secondary",staticStyle:{"width":"150px"},attrs:{"type":"filled"}},[_vm._v("ساخت سرور ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }